import { CitizenshipOptions } from '@master/model/options/CitizenshipOptions'
import { Ignore } from '@master/annotation/Ignore'
import { getRawKey, RawKey } from '@master/annotation/RawKey'
import { ClientInfoBase } from './ClientInfoBase'
export class ClientDependant extends ClientInfoBase {
  @RawKey('dependant_oid')
  oid = ''

  clientOid = undefined
  childClientOid = undefined
  citizenship = undefined
  nationality = undefined
  dateOfBirth = undefined
  gender = undefined
  name = undefined
  nric = undefined
  relationship = []
  smoker: 'Y' | 'N' | '' = ''
  occupation = undefined
  dependencyPeriod = undefined // in years

  convertToRawData () {
    const raw = super.convertToRawData()
    delete raw[getRawKey(this, 'oid')]
    return raw
  }

  @Ignore()
  get genderDisplay () {
    return this.genderOptions.find(gl => gl.value === this.gender)?.label
  }

  @Ignore()
  get citizenshipDisplay () {
    return CitizenshipOptions.find(cz => cz.value === this.citizenship)?.label
  }

  @Ignore()
  get relationshipDisplay () {
    return this.relationship?.join(', ')
  }

  @Ignore()
  get genderOptions () {
    return [
      {
        label: 'Male',
        value: 'male'
      },
      {
        label: 'Female',
        value: 'female'
      }
    ]
  }
}
